module.exports = __webpack_public_path__ + "img/a6.f4b9a8fb.jpg";